import { ActionIcon, Anchor, Box, Container, Divider, Group, Stack, Text } from '@mantine/core'
import { IconBrandTelegram, IconBrandInstagram, IconBrandTiktok, IconMail } from '@tabler/icons-react'
import { BRAND_NAME } from '../branding'
import LegalLinks from './LegalLinks'

type IconRenderer = (props: { size?: number }) => JSX.Element
type IconLink = { label: string; href: string; icon: IconRenderer }

const SOCIAL_LINKS: IconLink[] = [
  { label: 'Telegram', href: 'https://t.me/fravai', icon: (props) => <IconBrandTelegram {...props} /> },
  { label: 'Instagram', href: 'https://instagram.com/fravai_blog', icon: (props) => <IconBrandInstagram {...props} /> },
  { label: 'TikTok', href: 'https://tiktok.com/fravai.com', icon: (props) => <IconBrandTiktok {...props} /> }
]

const CONTACT_LINKS: IconLink[] = [
  { label: 'Поддержка', href: 'https://t.me/fravai_support_bot', icon: (props) => <IconBrandTelegram {...props} /> },
  { label: 'support@fravai.com', href: 'mailto:support@fravai.com', icon: (props) => <IconMail {...props} /> }
]

export default function SiteFooter() {
  return (
    <Box component="footer" style={{ background: 'var(--mantine-color-gray-0)' }}>
      <Divider opacity={0.35} />

      <Container size="lg" py="xl">
        <Stack gap="xl">
          <Group align="flex-start" justify="space-between" gap="xl" wrap="wrap">
            <Stack gap={8} style={{ minWidth: 220 }}>
              <Text fw={600} size="sm">Информация</Text>
              <LegalLinks orientation="vertical" size="sm" color="dimmed" />
            </Stack>

            <Stack gap={12} style={{ minWidth: 220 }} align="flex-start">
              <Text fw={600} size="sm">Контакты и соцсети</Text>
              <Group gap="xs">
                {SOCIAL_LINKS.map((item) => {
                  const Icon = item.icon
                  return (
                    <ActionIcon
                      key={item.label}
                      component="a"
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="lg"
                      variant="light"
                      radius="xl"
                      title={item.label}
                    >
                      <Icon size={18} />
                    </ActionIcon>
                  )
                })}
              </Group>
              <Stack gap={6}>
                {CONTACT_LINKS.map((item) => {
                  const Icon = item.icon
                  return (
                    <Group key={item.label} gap={6} wrap="nowrap" align="center">
                      <Icon size={16} />
                      <Anchor href={item.href} size="sm" c="dimmed" style={{ textDecoration: 'none' }}>
                        {item.label}
                      </Anchor>
                    </Group>
                  )
                })}
              </Stack>
            </Stack>
          </Group>

          <Divider opacity={0.35} />
          <Text size="xs" c="dimmed" ta="center">
            © 2026 {BRAND_NAME}. Все права защищены.
          </Text>
        </Stack>
      </Container>
    </Box>

  )
}
